export enum UploadStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  IMPORTED = 'IMPORTED',
  UPLOAD_ERROR = 'UPLOAD_ERROR',
  CONVERSION_ERROR = 'CONVERSION_ERROR',
  IMPORT_ERROR = 'IMPORT_ERROR',
}
export enum UploadStatuses {
  SUCCESS = 'SUCCESS',
  SUCCESS_COMPLETE = 'SUCCESS_COMPLETE',
  IN_PROGRESS = 'IN_PROGRESS',
  WARNING = 'WARNING',
  ERROR = 'ERROR',
  IMPORT_ERROR = 'IMPORT_ERROR',
  UPLOAD_ERROR = 'UPLOAD_ERROR',
  CONVERSION_ERROR = 'CONVERSION_ERROR',
}

export enum ClientFileStatus {
  UPLOADING = 'UPLOADING',
  UPLOAD_ERROR = 'UPLOAD_ERROR',
  UPLOADED = 'UPLOADED',
  CONVERTING = 'CONVERTING',
  CONVERSION_ERROR = 'CONVERSION_ERROR',
  CONVERTED = 'CONVERTED',
  IMPORTING = 'IMPORTING',
  IMPORT_ERROR = 'IMPORT_ERROR',
  OPEN = 'OPEN',
  DELETED = 'DELETED',
  MISSING_SIGN_OFF_REQUIREMENTS = 'MISSING_SIGN_OFF_REQUIREMENTS',
  UNSIGNED = 'UNSIGNED',
  PARTIALLY_SIGNED = 'PARTIALLY_SIGNED',
  FULLY_SIGNED = 'FULLY_SIGNED',
  RELEASING = 'RELEASING',
  RELEASED = 'RELEASED',
  RELEASE_ERROR = 'RELEASE_ERROR',
  CONVERTING_RELEASE = 'CONVERTING_RELEASE',
  CONVERTED_RELEASE = 'CONVERTED_RELEASE',
  CONVERSION_ERROR_RELEASE = 'CONVERSION_ERROR_RELEASE',
  PROCESSING = 'PROCESSING',
  PROCESSING_ERROR = 'PROCESSING_ERROR',
  SANCTION_HIT = 'SANCTION_HIT',
  SANCTION_SCREENING = 'SANCTION_SCREENING',
  RELEASED_TO_BANK = 'RELEASED_TO_BANK',
  COMPLETED_SUCCESSFULLY = 'COMPLETED_SUCCESSFULLY',
  COMPLETED_WITH_ERRORS = 'COMPLETED_WITH_ERRORS',
}
